import React from 'react'
import { StyledForm } from './styles'

const FormTxt = ({ placeholder, onChangeVal, ...rest }) => (
  <StyledForm
    type={'text'}
    placeholder={placeholder}
    onChange={e => onChangeVal(e)}
    {...rest}
  />
)

export default FormTxt